<template>
    <div class="text-left wpl-option-tiles-heading pt-xs-5">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'OptionTilesHeading'
}
</script>
